import { CmsSiteKey } from '@prisma-clinic/client'

import { api } from '../core/trpc'
import { useLocale } from './useLocale'

export type CmsNavLink = { href: string; label: string }

type CmsMenuItem = { id: string; order: number; label: string; link: string }

/**
 * The navigation entries an editor has authored, if any.
 *
 * These are additions to the product's own navigation rather than a replacement for it — see
 * `Header`. An editor can put a cms page in the header; an editor cannot accidentally take the
 * booking flow out of it.
 *
 * Links arrive already resolved — the public chrome read rewrites `page:<id>` into a path — so a
 * menu entry keeps working when the page behind it is renamed.
 */
export const useCmsSiteHeader = (): CmsNavLink[] | null => {
    const { locale } = useLocale()
    const { data } = api.cmsPage.getSiteHeader.useQuery({ siteKey: CmsSiteKey.LONGY, locale })

    const items = (data?.menuItems ?? []) as CmsMenuItem[]
    if (items.length === 0) return null

    return [...items]
        .sort((a, b) => a.order - b.order)
        .filter((item) => item.label !== '')
        .map((item) => ({ href: item.link, label: item.label }))
        .filter((link) => link.href !== '')
}
